export default function CTAForm() {
  return (
    <section className="py-16 md:py-20 bg-background-100" id="cta-form">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '800px' }}>
        <div className="bg-background-50 border border-background-200/60 rounded-lg p-7 md:p-10 text-center">
          <div className="mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Рассчитаем стоимость вашего проекта
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
              Напишите или позвоните — ответим и&nbsp;подготовим ориентировочную смету в&nbsp;течение дня
            </p>
          </div>

          <p className="text-sm text-foreground-500 mb-6">
            Выберите удобный способ связи
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href="https://wa.me/79174131562"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg"></i>
              </span>
              WhatsApp
            </a>

            <a
              href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-accent-600 hover:bg-accent-700 text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-chat-3-line text-lg"></i>
              </span>
              MAX
            </a>

            <a
              href="https://t.me/Gmgmg0202"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-telegram-line text-lg"></i>
              </span>
              Telegram
            </a>

            <a
              href="tel:+79174131562"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-7 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-lg"></i>
              </span>
              Позвонить
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}